import React, { useEffect, useState } from 'react'
import { Button, Table, Spinner, Row, Col, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RequiredLabel } from '../utils/validators';
import { getConcepts, activateConcept } from '../services/Concepts';

function Concepts() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleEdit = (id) => navigate(`/editConcept/${id}`);
    const addConceptRedirect = () => navigate(`/addconcept`);

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const concepts = await getConcepts();
            setData(concepts);
        } catch (error) {
            console.error(error);
            toast.error('Error al cargar conceptos');
        } finally {
            setIsLoading(false);
        }
    };

    const handleInactive = async (id) => {
        try {
            await activateConcept(id, false);
            toast.success('Concepto inactivado');
            fetchData();
        } catch (e) {
            toast.error('No se pudo inactivar');
        }
    };

    const handleActive = async (id) => {
        try {
            await activateConcept(id, true);
            toast.success('Concepto activado');
            fetchData();
        } catch (e) {
            toast.error('No se pudo activar');
        }
    };

    useEffect(() => { fetchData(); }, []);

    return (
        <div>
            <h2>Conceptos</h2>

            {isLoading ? (
                <Spinner animation="border" role="status" />
            ) : (
                <>
                    <Row>
                        <Col className='text-left'>
                            <Button className='m-3' variant="success" type="button" onClick={addConceptRedirect}>
                                Agregar concepto +
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th className='text-center'>#</th>
                                        <th className='text-center'>Editar</th>
                                        <th className='text-center'>Acción</th>
                                        <th className='text-center'>Nombre</th>
                                        <th className='text-center'>Estatus</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((c, idx) => (
                                        <tr key={c.id}>
                                            <td className='text-center'>{idx + 1}</td>
                                            <td className='text-center'>
                                                <Button size="sm" variant="warning" onClick={() => handleEdit(c.id)}>Editar</Button>
                                            </td>
                                            <td className='text-center'>
                                                {c.isActive ? (
                                                    <Button size="sm" variant="danger" onClick={() => handleInactive(c.id)}>Inactivar</Button>
                                                ) : (
                                                    <Button size="sm" variant="success" onClick={() => handleActive(c.id)}>Activar</Button>
                                                )}
                                            </td>
                                            <td>{c.description}</td>
                                            <td className='text-center'>
                                                {c.isActive ? <Badge bg="success">Activo</Badge> : <Badge bg="secondary">Inactivo</Badge>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </>
            )}
            <ToastContainer />
        </div>
    );
}

export default Concepts;